import React from "react"

import {MenuItem, Select, FormControl, InputLabel} from "@mui/material"
import {RegionCode, regions} from "@casas-diamante/types"
import {useRegion} from "@/context/RegionContext"

export default function RegionSelector() {
   const {selectedRegion, setSelectedRegion} = useRegion()
   return (
      <FormControl>
         <InputLabel id="region-selector-label">Región</InputLabel>
         <Select
            className = "bg-green-100"
            value={selectedRegion}
            size="small"
            onChange={(e) => setSelectedRegion(e.target.value as RegionCode)}
            label="Región"
         >
            {regions.map((region) => (
               <MenuItem key={region.code} value={region.code}>
                  {region.text}
               </MenuItem>
            ))}
         </Select>
      </FormControl>
   )
}
